import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function SearchBar() {
  const { t } = useTranslation('artists');
  const [searchParams, setSearchParams] = useSearchParams();
  const [query, setQuery] = useState(searchParams.get('q') || '');

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const params = new URLSearchParams(searchParams);
    if (query.trim()) {
      params.set('q', query.trim());
    } else {
      params.delete('q');
    }
    setSearchParams(params);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setQuery(e.target.value);
  };

  return (
    <form onSubmit={handleSearch} className="w-full max-w-2xl">
      <div className="relative flex items-center">
        <div className="absolute left-4 w-5 h-5 flex items-center justify-center text-gray-400">
          <i className="ri-search-line text-base"></i>
        </div>
        <input
          type="text"
          value={query}
          onChange={handleChange}
          placeholder={t('searchPlaceholder')}
          className="w-full pl-12 pr-14 py-3.5 text-sm bg-white border border-gray-200 rounded-full focus:outline-none focus:ring-2 focus:ring-amber-600/20 focus:border-amber-600 transition-all"
        />
        <button
          type="submit"
          className="absolute right-2 px-4 py-2 bg-gray-900 text-white text-sm font-medium rounded-full hover:bg-amber-700 transition-colors whitespace-nowrap"
        >
          {t('searchPlaceholder').split(' ')[0]}
        </button>
      </div>
    </form>
  );
}